// import React, { useEffect, useRef, useState } from "react";

// const RaceGame = ({ isMediumScreen, playbackUrl }) => {
//   const videoRef = useRef(null);
//   const playerRef = useRef(null);

//   const [isPlayerSupported, setIsPlayerSupported] = useState(true);
//   const [volume, setVolume] = useState(0.5);

//   useEffect(() => {
//     let scriptElement = null;
//     let mounted = true;

//     const loadIVSPlayer = () => {
//       return new Promise((resolve, reject) => {
//         if (document.querySelector('script[src*="amazon-ivs-player"]')) {
//           resolve();
//           return;
//         }

//         const script = document.createElement("script");
//         script.src =
//           "https://player.live-video.net/1.35.0/amazon-ivs-player.min.js";
//         script.async = true;
//         script.onload = resolve;
//         script.onerror = reject;
//         document.body.appendChild(script);
//         scriptElement = script;
//       });
//     };

//     const initializePlayer = async () => {
//       try {
//         await loadIVSPlayer();

//         if (!mounted) return;

//         if (!window.IVSPlayer || !window.IVSPlayer.isPlayerSupported) {
//           setIsPlayerSupported(false);
//           console.warn("The current browser does not support the IVS player.");
//           return;
//         }

//         const { IVSPlayer } = window;
//         const player = IVSPlayer.create();
//         playerRef.current = player;

//         if (videoRef.current) {
//           player.attachHTMLVideoElement(videoRef.current);

//           // Define event listener functions
//           const onPlaying = () => {
//             console.log("Player State - PLAYING");
//             console.log("Latency:", player.getLiveLatency());
//           };

//           const onEnded = () => {
//             console.log("Player State - ENDED");
//           };

//           const onError = (err) => {
//             console.warn("Player Event - ERROR:", err);
//           };

//           const onBuffering = () => {
//             console.log("Player State - BUFFERING");
//           };

//           // Store event listeners on the player instance for cleanup
//           player._eventListeners = {
//             playing: onPlaying,
//             ended: onEnded,
//             error: onError,
//             buffering: onBuffering,
//           };

//           // Add event listeners
//           player.addEventListener(IVSPlayer.PlayerState.PLAYING, onPlaying);
//           player.addEventListener(IVSPlayer.PlayerState.ENDED, onEnded);
//           player.addEventListener(IVSPlayer.PlayerEventType.ERROR, onError);
//           player.addEventListener(IVSPlayer.PlayerState.BUFFERING, onBuffering);

//           player.setAutoplay(true);
//           player.setVolume(volume);

//           if (playbackUrl) {
//             player.load(playbackUrl);
//           }
//         }
//       } catch (error) {
//         console.error("Error initializing IVS player:", error);
//       }
//     };

//     initializePlayer();

//     return () => {
//       mounted = false;
//       if (playerRef.current) {
//         try {
//           const player = playerRef.current;
//           const { IVSPlayer } = window;

//           // Pause the player
//           player.pause();

//           // Remove event listeners using stored references
//           if (player._eventListeners) {
//             player.removeEventListener(
//               IVSPlayer.PlayerState.PLAYING,
//               player._eventListeners.playing
//             );
//             player.removeEventListener(
//               IVSPlayer.PlayerState.ENDED,
//               player._eventListeners.ended
//             );
//             player.removeEventListener(
//               IVSPlayer.PlayerEventType.ERROR,
//               player._eventListeners.error
//             );
//             player.removeEventListener(
//               IVSPlayer.PlayerState.BUFFERING,
//               player._eventListeners.buffering
//             );
//           }

//           // Delete the player
//           player.delete();
//           playerRef.current = null;
//         } catch (error) {
//           console.error("Error cleaning up player:", error);
//         }
//       }
//       if (scriptElement && document.body.contains(scriptElement)) {
//         document.body.removeChild(scriptElement);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (playerRef.current) {
//       playerRef.current.setVolume(volume);
//     }
//   }, [volume]);

//   useEffect(() => {
//     if (playerRef.current && playbackUrl) {
//       playerRef.current.load(playbackUrl);
//     }
//   }, [playbackUrl]);

//   if (!isPlayerSupported) {
//     return (
//       <div className="w-full p-4 text-center text-red-500">
//         Your browser does not support the IVS player.
//       </div>
//     );
//   }

//   return (
//     <div
//       className={`w-full relative ${
//         isMediumScreen ? "" : "rounded-xl overflow-hidden"
//       }`}
//       // style={{ maxHeight: "600px", aspectRatio: "16/9" }}
//     >
//       <video
//         ref={videoRef}
//         className="w-full h-full object-cover"
//         playsInline
//         controls
//         style={{
//           width: "100%",
//           height: "auto",
//           borderRadius: isMediumScreen ? 0 : "12px",
//           maxHeight: "600px",
//           objectFit: "cover",
//         }}
//       />
//       <style jsx>{`
//         video::-webkit-media-controls-timeline,
//         video::-webkit-media-controls-current-time-display {
//           display: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default RaceGame;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Stage,
//   StageConnectionState,
//   StageEvents,
//   SubscribeType,
// } from "amazon-ivs-web-broadcast";

// class BroadcastStrategy {
//   constructor() {
//     this.shouldPublishParticipant = this.shouldPublishParticipant.bind(this);
//     this.shouldSubscribeToParticipant =
//       this.shouldSubscribeToParticipant.bind(this);
//     this.subscribeConfiguration = this.subscribeConfiguration.bind(this);
//   }

//   shouldPublishParticipant() {
//     return false;
//   }

//   shouldSubscribeToParticipant(participant) {
//     return !participant.isLocal;
//   }

//   subscribeConfiguration(participant) {
//     return {
//       video: SubscribeType.WATCH,
//       audio: SubscribeType.WATCH,
//     };
//   }
// }

// const RaceGame = ({ participantToken, isMediumScreen }) => {
//   const videoRef = useRef(null);
//   const stageRef = useRef(null);
//   const cleanupInProgressRef = useRef(false);
//   const currentStreamRef = useRef(null);
//   const reconnectTimeoutRef = useRef(null);
//   const [isConnected, setIsConnected] = useState(false);
//   const [participants, setParticipants] = useState(new Map());
//   const [error, setError] = useState(null);
//   const strategyRef = useRef(new BroadcastStrategy());
//   const [streamRetryCount, setStreamRetryCount] = useState(0);
//   const MAX_RETRY_ATTEMPTS = 3;
//   const RETRY_DELAY = 2000;

//   const cleanupStream = () => {
//     if (videoRef.current && videoRef.current.srcObject) {
//       const stream = videoRef.current.srcObject;
//       stream.getTracks().forEach((track) => {
//         track.stop();
//       });
//       videoRef.current.srcObject = null;
//     }
//     currentStreamRef.current = null;
//   };

//   const handleStreamError = () => {
//     if (streamRetryCount < MAX_RETRY_ATTEMPTS) {
//       console.log(
//         `Stream error occurred. Attempt ${
//           streamRetryCount + 1
//         } of ${MAX_RETRY_ATTEMPTS}`
//       );
//       setStreamRetryCount((prev) => prev + 1);

//       if (reconnectTimeoutRef.current) {
//         clearTimeout(reconnectTimeoutRef.current);
//       }

//       reconnectTimeoutRef.current = setTimeout(() => {
//         if (stageRef.current) {
//           cleanupStream();
//           stageRef.current.refreshStrategy();
//         }
//       }, RETRY_DELAY);
//     } else {
//       console.log("Max retry attempts reached. Stream may be unavailable.");
//       setError("Stream unavailable after multiple attempts");
//     }
//   };

//   const cleanup = async () => {
//     if (cleanupInProgressRef.current) return;
//     cleanupInProgressRef.current = true;

//     try {
//       if (reconnectTimeoutRef.current) {
//         clearTimeout(reconnectTimeoutRef.current);
//         reconnectTimeoutRef.current = null;
//       }

//       cleanupStream();

//       if (stageRef.current) {
//         const stage = stageRef.current;
//         stage.removeAllListeners();
//         await stage.leave();
//         stageRef.current = null;
//       }

//       setStreamRetryCount(0);
//     } catch (error) {
//       console.error("Cleanup error:", error);
//     } finally {
//       cleanupInProgressRef.current = false;
//     }
//   };

//   useEffect(() => {
//     let abortController = new AbortController();

//     const initializeStage = async () => {
//       await cleanup();
//       if (abortController.signal.aborted) return;

//       try {
//         if (!participantToken) {
//           throw new Error("Participant token is required");
//         }

//         const stage = new Stage(participantToken, strategyRef.current);
//         stageRef.current = stage;

//         stage.on(StageEvents.STAGE_CONNECTION_STATE_CHANGED, (state) => {
//           if (abortController.signal.aborted) return;
//           console.log("Stage connection state:", state);
//           setIsConnected(state === StageConnectionState.CONNECTED);

//           if (state === StageConnectionState.DISCONNECTED) {
//             cleanupStream();
//           }
//         });

//         stage.on(
//           StageEvents.STAGE_PARTICIPANT_STREAMS_ADDED,
//           (participant, streams) => {
//             if (abortController.signal.aborted || participant.isLocal) return;

//             const videoStream = streams.find(
//               (stream) => stream.mediaStreamTrack.kind === "video"
//             );

//             if (videoStream && videoRef.current) {
//               try {
//                 // Clean up existing stream before attaching new one
//                 cleanupStream();

//                 const mediaStream = new MediaStream([
//                   videoStream.mediaStreamTrack,
//                 ]);
//                 videoRef.current.srcObject = mediaStream;
//                 currentStreamRef.current = mediaStream;
//                 setStreamRetryCount(0); // Reset retry count on successful stream

//                 // Add error handler to video element
//                 videoRef.current.onerror = handleStreamError;
//               } catch (err) {
//                 console.error("Error attaching stream:", err);
//                 handleStreamError();
//               }
//             }
//           }
//         );

//         // Handle stream errors at the stage level
//         stage.on(StageEvents.STAGE_STREAM_ERROR, () => {
//           if (!abortController.signal.aborted) {
//             handleStreamError();
//           }
//         });

//         await stage.join();

//         if (!abortController.signal.aborted) {
//           console.log("Successfully joined stage");
//         }
//       } catch (err) {
//         if (!abortController.signal.aborted) {
//           console.error("Stage initialization error:", err);
//           setError(err.message);
//         }
//       }
//     };

//     initializeStage();

//     return () => {
//       abortController.abort();
//       cleanup();
//     };
//   }, [participantToken]);

//   // Additional cleanup on unmount
//   useEffect(() => {
//     return () => cleanup();
//   }, []);

//   if (error) {
//     return (
//       <div className="w-full p-4 text-center text-red-500">Error: {error}</div>
//     );
//   }

//   return (
//     <div
//       className={`w-full relative ${
//         isMediumScreen ? "" : "rounded-xl overflow-hidden"
//       }`}
//     >
//       <video
//         ref={videoRef}
//         className="w-full h-full object-cover"
//         playsInline
//         autoPlay
//         style={{
//           width: "100%",
//           height: "auto",
//           borderRadius: isMediumScreen ? 0 : "12px",
//           maxHeight: "600px",
//           objectFit: "cover",
//         }}
//       />
//       {!isConnected && (
//         <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
//           <div className="text-white">
//             {streamRetryCount > 0
//               ? `Reconnecting... Attempt ${streamRetryCount} of ${MAX_RETRY_ATTEMPTS}`
//               : "Connecting to stage..."}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RaceGame;

import React, { useEffect, useRef, useState } from "react";
import {
  Stage,
  StageConnectionState,
  StageEvents,
} from "amazon-ivs-web-broadcast";
import { BroadcastStrategy } from "../strategy";
import useApiRequest from "../../../api/api";
import apiRoutes from "../../../api/routes";
import { useSearchParams } from "react-router-dom";

// Define the strategy class

const RaceGame = ({ isMediumScreen }) => {
  const { makeApiCall } = useApiRequest();
  const videoRef = useRef(null);
  const stageRef = useRef(null);
  const cleanupInProgressRef = useRef(false);
  const [isConnected, setIsConnected] = useState(false);
  const [participants, setParticipants] = useState(new Map());
  const [error, setError] = useState(null);
  const strategyRef = useRef(new BroadcastStrategy());
  const [participantToken, setParticipantToken] = useState("");
  const [searchParams] = useSearchParams();
  const identifier = searchParams.get("id");
  const [expirationTime, setExpirationTime] = useState(null);
  // Separate cleanup function that can be called both in useEffect and componentWillUnmount
  const cleanup = async () => {
    if (cleanupInProgressRef.current) return;
    cleanupInProgressRef.current = true;

    try {
      if (videoRef.current) {
        const stream = videoRef.current.srcObject;
        if (stream) {
          stream.getTracks().forEach((track) => track.stop());
          videoRef.current.srcObject = null;
        }
      }

      if (stageRef.current) {
        const stage = stageRef.current;

        // Remove all event listeners
        stage.removeAllListeners();

        // Leave the stage
        await stage.leave();

        stageRef.current = null;
      }
    } catch (error) {
      console.error("Error during cleanup:", error);
    } finally {
      cleanupInProgressRef.current = false;
    }
  };
  let abortController = new AbortController();

  const initializeStage = async () => {
    // Run cleanup before initializing new stage
    await cleanup();

    if (abortController.signal.aborted) return;

    try {
      if (!participantToken) {
        setError("Participant token is required");
        return;
      }

      const stage = new Stage(participantToken, strategyRef.current);
      stageRef.current = stage;

      stage.on(StageEvents.STAGE_CONNECTION_STATE_CHANGED, (state) => {
        if (abortController.signal.aborted) return;
        setIsConnected(state === StageConnectionState.CONNECTED);
      });

      stage.on(StageEvents.STAGE_PARTICIPANT_JOINED, (participant) => {
        if (abortController.signal.aborted) return;
        if (!participant.isLocal) {
          setParticipants(
            (prev) =>
              new Map(
                prev.set(participant.id, {
                  ...participant,
                  streams: [],
                })
              )
          );
        }
      });

      stage.on(StageEvents.STAGE_PARTICIPANT_LEFT, (participant) => {
        if (abortController.signal.aborted) return;
        setParticipants((prev) => {
          const newMap = new Map(prev);
          newMap.delete(participant.id);
          return newMap;
        });
      });

      stage.on(
        StageEvents.STAGE_PARTICIPANT_STREAMS_ADDED,
        (participant, streams) => {
          if (abortController.signal.aborted) return;

          if (!participant.isLocal) {
            const videoStream = streams.find(
              (stream) => stream.mediaStreamTrack.kind === "video"
            );

            if (videoStream && videoRef.current) {
              const mediaStream = new MediaStream([
                videoStream.mediaStreamTrack,
              ]);
              videoRef.current.srcObject = mediaStream;
            }

            setParticipants((prev) => {
              const existingParticipant = prev.get(participant.id);
              if (existingParticipant) {
                return new Map(
                  prev.set(participant.id, {
                    ...existingParticipant,
                    streams: [...existingParticipant.streams, ...streams],
                  })
                );
              }
              return prev;
            });
          }
        }
      );

      await stage.join();
      if (!abortController.signal.aborted) {
      }
    } catch (err) {
      if (!abortController.signal.aborted) {
        console.error("Error initializing stage:", err);
        setError(err.message);
      }
    }
  };
  const fetchParticipantToken = async () => {
    const response = await makeApiCall(
      apiRoutes.races.getToken(identifier),
      "GET"
    );
    if (response?.data) {
      setParticipantToken(response.data.participantToken.token);
      setExpirationTime(response.data.participantToken.expirationTime);
    }
  };
  useEffect(() => {
    let tokenRefreshTimeout;

    const scheduleTokenRefresh = (expiresAt) => {
      const now = new Date().getTime();
      const expirationTime = new Date(expiresAt).getTime();
      const refreshTime = expirationTime - now - 5000; // Refresh 5s before expiry
      if (refreshTime > 0) {
        tokenRefreshTimeout = setTimeout(async () => {
          await fetchParticipantToken(); // Fetch new token
        }, refreshTime);
      }
    };

    if (participantToken) {
      initializeStage();
      scheduleTokenRefresh(expirationTime);
    }

    return () => {
      abortController.abort();
      cleanup();
      clearTimeout(tokenRefreshTimeout);
    };
  }, [participantToken]);

  // Add an unmount handler using useEffect
  useEffect(() => {
    return () => {
      cleanup();
    };
  }, []);
  useEffect(() => {
    fetchParticipantToken();
  }, []);
  if (error) {
    return (
      <div className="w-full p-4 text-center text-red-500">Error: {error}</div>
    );
  }

  return (
    <div
      className={`w-full relative ${
        isMediumScreen ? "" : "rounded-xl overflow-hidden"
      }`}
    >
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        playsInline
        controls
        autoPlay
        style={{
          width: "100%",
          height: "auto",
          borderRadius: isMediumScreen ? 0 : "12px",
          maxHeight: "600px",
          objectFit: "cover",
        }}
      />
      {!isConnected && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="text-white">Connecting to stage...</div>
        </div>
      )}
    </div>
  );
};

export default RaceGame;
